/**
 * @file interset
 * @author 丁聪
 */

import React, { Component } from "react";
import "./index.scss";

class Many extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {}

  componentWillUnmount() {
    // window.removeEventListener('scroll', this.handleScroll)
  }

  render() {
    return (
      <div id="many">
        <div className="many-first">
          <div className="inner-title">多等级课程体系，为孩子智能匹配课程</div>
          <div className="many-text">
            <div>
              哈兔中文为您提供全面的评测，确定学员级别，并有资深课程顾问为您量身定制课程
            </div>
            <br />
            <div>
              哈兔中文的课程体系经过专业教研团队精心打造，采用科学、严谨的方式进行分级和编排，课程共分为4个阶段、12个级别
              <br />
              <br />
              哈兔中文的课程契合中国小学义务教育阶段语文学习，面向海外华人孩子及有中文学习需求的孩子，针对不同中文水平孩子设置对应的课程，全面满足您的中文学习需求
            </div>
            <br />
            <div>
              哈兔中文课堂为全程互动课堂，使孩子在高效学习的过程中有充分的时间享受我们提供的优质服务，每一步都脚踏实地，在完成既定课时后，能够达到对应级别的语言水平。
            </div>
          </div>
          <img
            className="img"
            src="//cdn.ihatoo.com/hatu-official/course/new/f1-tu1.svg"
          />
        </div>
      </div>
    );
  }
}

export default Many;
